import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ParentStylingService {
	private _renderer: Renderer2;

	private _parentElementToClasses: Map<HTMLElement, string[]> = new Map();

	constructor(
		private _router: Router,
		private _rendererFactory: RendererFactory2
	) {
		this._renderer = this._rendererFactory.createRenderer(null, null);

		this._router.events.pipe(
			filter((event) => event instanceof NavigationEnd)
		).subscribe(
			() => {
				for (let [element, classes] of this._parentElementToClasses.entries()) {
					for (let className of classes) {
						this._renderer.removeClass(element, className);
					}
				}
				this._parentElementToClasses.clear();
			}
		);
	}

	public addClassToParentUntilNavigationEnd(element: HTMLElement, className: string) {
		let parentElement: HTMLElement | null = element.parentElement;
	
		if (parentElement) {
			if (this._parentElementToClasses.has(parentElement)) {
				// If there's already a key for this element, append the new class to the existing array.
				const existingClasses = this._parentElementToClasses.get(parentElement);
				
				if (existingClasses) {
					existingClasses.push(className);
				}
			} else {
				// If there's no key for this element, create a new array with this class.
				this._parentElementToClasses.set(parentElement, [className]);
			}
	
			this._renderer.addClass(parentElement, className);
		}
	}
	
}